import { render, staticRenderFns } from "./GeneralFlags.vue?vue&type=template&id=84b9ef04&scoped=true&"
import script from "./GeneralFlags.vue?vue&type=script&lang=js&"
export * from "./GeneralFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9ef04",
  null
  
)

export default component.exports